import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import {Icon} from 'semantic-ui-react';
import _ from 'lodash';

const AddressToolTip = ({elementId, address}) => (
    <div>
        <strong><a data-tip data-for={elementId} href='javascript:;'>{_.isObject(address) ? address.label : <br />}</a></strong>
        <ReactTooltip id={elementId} aria-haspopup='true' place="right">
            {_.isObject(address) ? <p>
                <Icon name='building' />{address.company} <br />
                <Icon name='address card outline' />{address.address_1}{address.address_2 ? ` , ${address.address_2}` : ""} <br />
                <Icon name='address card outline' />
                    {address.city}{address.state ? ` , ${address.state}` : ""} {address.postcode ? ` , ${address.postcode}` : ""} 
                    <br />
                <Icon name='user' />{address.first_name} {address.last_name} <br />
                <Icon name='mail' />{address.email} <br />
                <Icon name='phone' />{address.phone}
            </p> : <p></p>}
        </ReactTooltip>
    </div>
)

AddressToolTip.propTypes = {
    address: PropTypes.object,
    elementId: PropTypes.string.isRequired
};


export default AddressToolTip


// WEBPACK FOOTER //
// ./src/components/orders/parts/AddressToopTips.js